<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex shrink>
        <v-select
          :items="items"
          hide-details
          v-model="chapterSelected"
          @change="handleChapter"
          dense
          solo
        ></v-select>
      </v-flex>
      <v-flex class="ml-2" shrink v-if="clearChapterSelected > 10">
        <v-select
          :items="levelItems"
          hide-details
          v-model="levelSelected"
          @change="handleLevel"
          dense
          solo
        ></v-select>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <template v-if="loading">
          <!-- <v-btn outline loading color="grey"></v-btn> -->
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
            <v-btn color="grey" outline>
              <em class="fas fa-file-import" />
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <em class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
        </template>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headerQuestion"
      :items="showDataTable"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.subChapter }}</td>
          <td>
            {{
              props.item.question && props.item.question.question
                ? props.item.question.question
                : '-'
            }}
          </td>
          <td>
            {{ props.item.countFail }}
            <span
              @click="
                showUserList = 1
                updateShowUsers(props.item.users)
              "
              class="underline primary-color cursor-pointer"
              >{{ $t('Detail') }}</span
            >
          </td>
        </tr>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No data') }}</div>
    </v-data-table>

    <v-dialog v-model="showUserList" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showUserList = 0"> X </v-btn>
        </div>
        <v-divider></v-divider>

        <v-data-table
          :headers="activeUserSelectHeaders"
          :items="activeUserSelectData"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.first_name || '' }} {{ props.item.last_name || '' }}</td>
              <td>{{ props.item.age || '-' }}</td>
              <td>{{ props.item.phoneno || '-' }}</td>
              <td>{{ props.item.email || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import atomicboyApi from '@/api/atomicboy'

export default {
  data() {
    return {
      showDataTable: [],
      loading: true,
      chapterSelected: 'บทที่ 1',
      items: [
        'บทที่ 1',
        'บทที่ 2',
        'บทที่ 3',
        'บทที่ 4',
        'บทที่ 5',
        'บทที่ 6',
        'บทที่ 7',
        'บทที่ 8',
        'บทที่ 9',
        'บทที่ 10',
        'บทที่ 11',
        'บทที่ 12',
        'บทที่ 13'
      ],
      levelItems: ['All', 'Encourage', 'Standard', 'Challenge'],
      mapLevel: { All: null, Encourage: 'E', Standard: 'N', Challenge: 'H' },
      levelSelected: 'All',
      headerQuestion: [
        { text: 'บท', value: 'subChapter' },
        { text: 'คำถาม', sortable: false },
        { text: 'จำนวนนักเรียนที่ตอบผิด', sortable: false }
      ],
      showUserList: 0,
      data: [],
      activeUserSelectHeaders: [
        { text: 'ชื่อ', value: 'name' },
        { text: 'อายุ', value: 'age' },
        { text: 'เบอร์โทรศัพท์', value: 'phone' },
        { text: 'อีเมล', value: 'email' }
      ],
      activeUserSelectData: [],
      itemsPerPage: 8
    }
  },
  computed: {
    ...mapGetters({
      isCoachlab: 'isCoachlab',
      selectedBot: 'selectedBot'
    }),
    clearChapterSelected() {
      return parseInt(this.chapterSelected.split(' ')[1])
    }
  },
  mounted() {
    this.fetchReport()
  },
  methods: {
    handleChapter() {
      this.levelSelected = 'All'
      this.fetchReport()
    },
    handleLevel() {
      this.fetchReport()
    },
    async fetchReport() {
      this.loading = true
      let body = {
        pageid: this.selectedBot.pageid,
        chapter: this.clearChapterSelected,
        level: this.mapLevel[this.levelSelected]
      }
      try {
        let resData = await atomicboyApi.falseQuestionReport(body)
        if (resData && resData.data) {
          resData = resData.data
          this.loading = false
          this.showDataTable = resData.data
        } else {
          throw 'No data return'
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    updateShowUsers(data) {
      this.activeUserSelectData = data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/AtomicboyFalesQuestion.vue